import { account } from '../core/account.js';
import { i18n, t } from '../core/i18n.js';
import { notify } from '../core/notify.js';
import { escapeHtml, formatDate } from '../core/utils.js';
import { openExternal } from '../core/external.js';

/* Pagos de Stripe (solo administradores, solo lectura): los cobros se leen de Stripe y se enlazan con la licencia que generaron.
   Buscar por correo, clave o referencia; filtrar por estado (cobrado, devuelto, fallido) y por tipo (licencia, dispositivo extra). */

let seq = 0;

const money = (cents, currency) => {
    try { return new Intl.NumberFormat(i18n.lang, { style: 'currency', currency: currency || 'EUR' }).format((cents || 0) / 100); } catch (e) { return ((cents || 0) / 100).toFixed(2) + ' ' + (currency || ''); }
};

export function openPaymentsAdmin() {
    const app = window.app;
    const id = 'payadm-' + (++seq) + '-' + Date.now().toString(36);
    const popup = app.popup.create({
        content: `<div class="popup catpick-popup admin-popup" id="${id}">
            <div class="view"><div class="page">
                <div class="navbar"><div class="navbar-bg"></div><div class="navbar-inner">
                    <div class="title">${escapeHtml(t('payAdmin.title'))}</div>
                    <div class="right"><a href="#" class="link popup-close" aria-label="${escapeHtml(t('common.close'))}"><span class="mi">close</span></a></div>
                </div></div>
                <div class="page-content licadm-content"><div data-adm><div class="spinner"></div></div></div>
            </div></div>
        </div>`,
        on: {
            open(p) {
                const body = p.el.querySelector('[data-adm]');
                const f = { q: '', state: 'all', kind: 'all' };
                let list = []; let page = 1; let pages = 1; let found = 0; let sums = null; let mode = 'test'; let truncated = false; let timer = null;
                const chip = (key, on, label) => `<button type="button" class="chip ${on ? 'is-active' : ''}" data-chip="${key}">${escapeHtml(label)}</button>`;

                const row = (x) => `<div class="admin-user licadm-card">
                    <div class="licadm-head">
                        <b class="payadm-amount">${escapeHtml(money(x.amount, x.currency))}</b>
                        <span class="tag payadm-${x.state}">${escapeHtml(t('payAdmin.state.' + x.state))}</span>
                        <span class="admin-user-sub payadm-when">${escapeHtml(formatDate(x.at, i18n.lang))}</span>
                    </div>
                    <div class="admin-user-sub">${escapeHtml(x.email || '—')}${x.refunded ? ' · ' + escapeHtml(t('payAdmin.refundedOf', { amount: money(x.refunded, x.currency) })) : ''}</div>
                    <div class="admin-user-sub">${escapeHtml(t('payAdmin.kind.' + x.kind, { n: x.qty }))}${x.key ? ' · <button type="button" class="licadm-key payadm-key" data-copy="' + escapeHtml(x.key) + '">' + escapeHtml(x.key) + '</button>' : ''}</div>
                    ${x.failure ? `<div class="admin-user-sub licadm-full">${escapeHtml(x.failure)}</div>` : ''}
                    <div class="payadm-links">
                        ${x.receipt ? `<button type="button" class="btn btn-sm" data-url="${escapeHtml(x.receipt)}"><span class="mi">receipt_long</span>${escapeHtml(t('payAdmin.receipt'))}</button>` : ''}
                        <button type="button" class="btn btn-sm" data-url="https://dashboard.stripe.com/${x.livemode ? '' : 'test/'}payments/${escapeHtml(x.paymentIntent || x.id)}"><span class="mi">open_in_new</span>Stripe</button>
                    </div></div>`;

                const frame = () => {
                    body.innerHTML = `<div class="payadm-mode" data-mode></div>
                        <div class="payadm-tiles" data-tiles></div>
                        <div class="licadm-search"><span class="mi">search</span><input type="search" data-q value="${escapeHtml(f.q)}" placeholder="${escapeHtml(t('payAdmin.search'))}" autocomplete="off" autocapitalize="off" spellcheck="false"/></div>
                        <div class="chips licadm-chips" data-chips></div>
                        <div class="admin-user-sub licadm-count" data-count></div>
                        <div class="admin-list" data-results></div>
                        <div class="licadm-more" data-more-wrap hidden><button type="button" class="btn btn-block" data-load-more>${escapeHtml(t('licAdmin.more'))}</button></div>
                        <div class="licadm-more"><button type="button" class="btn btn-block" data-refresh><span class="mi">refresh</span>${escapeHtml(t('payAdmin.refresh'))}</button></div>`;
                };
                const paint = () => {
                    body.querySelector('[data-mode]').innerHTML = `<span class="tag ${mode === 'live' ? 'payadm-paid' : ''}">${escapeHtml(t('payAdmin.mode.' + mode))}</span>${truncated ? ` <span class="admin-user-sub">${escapeHtml(t('payAdmin.truncated'))}</span>` : ''}`;
                    const c = (sums && sums.currency) || 'EUR';
                    body.querySelector('[data-tiles]').innerHTML = sums ? [
                        [t('payAdmin.net'), money(sums.net, c)], [t('payAdmin.last30'), money(sums.last30, c)], [t('payAdmin.refunded'), money(sums.refunded, c)], [t('payAdmin.count'), String(sums.count)]
                    ].map((x) => `<div class="payadm-tile"><small>${escapeHtml(x[0])}</small><b>${escapeHtml(x[1])}</b></div>`).join('') : '';
                    body.querySelector('[data-chips]').innerHTML = [
                        chip('s:all', f.state === 'all', t('payAdmin.stateAll')), chip('s:paid', f.state === 'paid', t('payAdmin.state.paid')), chip('s:refunded', f.state === 'refunded', t('payAdmin.state.refunded')), chip('s:failed', f.state === 'failed', t('payAdmin.state.failed') + (sums && sums.failed ? ' (' + sums.failed + ')' : '')),
                        chip('k:license', f.kind === 'license', t('payAdmin.kindChip.license')), chip('k:extra', f.kind === 'extra', t('payAdmin.kindChip.extra')), chip('k:unlinked', f.kind === 'unlinked', t('payAdmin.kindChip.unlinked'))
                    ].join('');
                    body.querySelector('[data-results]').innerHTML = list.length ? list.map(row).join('') : `<div class="empty"><span class="mi">payments</span><p>${escapeHtml(t('payAdmin.empty'))}</p></div>`;
                    body.querySelector('[data-count]').textContent = t('payAdmin.found', { n: found, shown: list.length });
                    body.querySelector('[data-more-wrap]').hidden = page >= pages;
                };
                const load = async ({ more = false, refresh = false } = {}) => {
                    if (!more) page = 1;
                    try {
                        const qs = new URLSearchParams({ q: f.q, state: f.state, kind: f.kind, page: String(page), limit: '25' });
                        if (refresh) qs.set('refresh', '1');
                        const r = await account.request('GET', '/api/admin/payments?' + qs.toString());
                        sums = r.sums; mode = r.mode; found = r.found; pages = r.pages; truncated = !!r.truncated;
                        list = more ? list.concat(r.payments) : r.payments;
                        if (!body.querySelector('[data-results]')) frame();
                        paint();
                    } catch (e) {
                        body.innerHTML = `<div class="phone-status is-error">${escapeHtml(t(e && e.code === 'stripe_not_configured' ? 'payAdmin.notConfigured' : e && e.code === 'stripe_error' ? 'payAdmin.stripeError' : 'common.errorNetwork'))}</div>`;
                    }
                };

                body.addEventListener('click', async (e) => {
                    const copy = e.target.closest('[data-copy]');
                    if (copy) { try { await navigator.clipboard.writeText(copy.getAttribute('data-copy')); } catch (err) { /* sin portapapeles */ } return notify.toast(t('licAdmin.copied'), { icon: 'content_copy', duration: 1800 }); }
                    const url = e.target.closest('[data-url]');
                    if (url) return openExternal(url.getAttribute('data-url'));
                    const ch = e.target.closest('[data-chip]');
                    if (ch) {
                        const [kind, val] = ch.getAttribute('data-chip').split(':');
                        if (kind === 's') f.state = val; else f.kind = f.kind === val ? 'all' : val;
                        return load();
                    }
                    if (e.target.closest('[data-load-more]')) { page += 1; return load({ more: true }); }
                    if (e.target.closest('[data-refresh]')) return load({ refresh: true });
                });
                body.addEventListener('input', (e) => {
                    if (!e.target.matches('[data-q]')) return;
                    clearTimeout(timer);
                    timer = setTimeout(() => { f.q = e.target.value.trim(); load(); }, 300);
                });
                frame();
                load();
            },
            closed(p) { try { p.destroy(); } catch (e) { /* ya cerrado */ } }
        }
    });
    popup.open();
}
